module.exports = __webpack_public_path__ + "img/ring_y_o_0_1@2x.5143e7bd.png";